"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const fonts = __importStar(require("../internal/fonts"));
const Inline_1 = require("./Inline");
class InlineIcon extends Inline_1.Inline {
    constructor(icon) {
        super();
        this._icon = icon || {};
    }
    width({ ctx }) {
        const icon = this._icon;
        if (icon.width) {
            return icon.width;
        }
        if (icon.font && fonts.check(icon.font, icon.content || "")) {
            ctx.save();
            ctx.canvas.style.letterSpacing = "normal";
            try {
                ctx.font = icon.font || ctx.font;
                return ctx.measureText(icon.content || "").width;
            }
            finally {
                ctx.canvas.style.letterSpacing = "";
                ctx.restore();
            }
        }
        return 0; //unknown
    }
    font() {
        var _a;
        return (_a = this._icon.font) !== null && _a !== void 0 ? _a : null;
    }
    color() {
        var _a;
        return (_a = this._icon.color) !== null && _a !== void 0 ? _a : null;
    }
    canDraw() {
        const icon = this._icon;
        return icon.font ? fonts.check(icon.font, icon.content || "") : true;
    }
    onReady(callback) {
        const icon = this._icon;
        if (icon.font && !fonts.check(icon.font, icon.content || "")) {
            fonts.load(icon.font, icon.content || "", callback);
        }
    }
    draw({ ctx, canvashelper, rect, offset, offsetLeft, offsetRight, offsetTop, offsetBottom, }) {
        const icon = this._icon;
        if (icon.content) {
            ctx.canvas.style.letterSpacing = "normal";
            try {
                // eslint-disable-next-line no-self-assign
                ctx.font = ctx.font; // To apply letterSpacing, we need to reset it.
                canvashelper.fillTextRect(ctx, icon.content, rect.left, rect.top, rect.width, rect.height, {
                    offset: offset + 1,
                    padding: {
                        left: offsetLeft,
                        right: offsetRight,
                        top: offsetTop,
                        bottom: offsetBottom,
                    },
                });
            }
            finally {
                ctx.canvas.style.letterSpacing = "";
            }
        }
    }
    canBreak() {
        return false;
    }
    toString() {
        return "";
    }
}
exports.InlineIcon = InlineIcon;
